var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"input",attrs:{"type":"text","id":"pac-input","placeholder":"장소명이나 주소"}})}
var staticRenderFns = []

export { render, staticRenderFns }